import jwt from 'jsonwebtoken';
import { isModernApi } from '../../index';
import { getDocumentContent } from '../integration';

export const getDocumentArrayBufferExternal = (user, imageid) => {
  const token = jwt.decode(user.access_token);
  if (isModernApi()) {
    return getDocumentContent(user.access_token, token.client, imageid, 'prod');
  }
  //decode jwt to get client
  const client = token.client;
  const url = `https://${client}/external/pdfexport.pdf?image.superid=${imageid}`;
  return fetch(url, {
    headers: {
      Authorization: `Bearer ${user.access_token}`
    },
    credentials: 'same-origin'
  }).then(response => {
    if (response.status !== 200) {
      return Promise.reject(`Returned code ${response.status}`);
    }
    var contentType = response.headers.get('content-type');
    if (contentType === 'text/html') {
      return Promise.reject('NotAuthenticated');
    }
    if (isModernApi()) {
      return response.text();
    }
    return response.arrayBuffer();
  });
};

export const getThumbnail = (user, imageid) => {
  const token = jwt.decode(user.access_token);
  //decode jwt to get client
  const client = token.client;
  const url = isModernApi()
    ? `https://docmanagement.parchment.com/v1/api/archive/${client}/document/${imageid}/thumb`
    : `https://${client}/external/thumbnail.jpg?image.superid=${imageid}`;
  return fetch(url, {
    headers: {
      Authorization: `Bearer ${user.access_token}`
    },
    credentials: 'same-origin'
  }).then(response => {
    if (response.status !== 200) {
      return Promise.reject(`Returned code ${response.status}`);
    }
    var contentType = response.headers.get('content-type');
    if (contentType === 'text/html') {
      return Promise.reject('NotAuthenticated');
    }
    if (isModernApi()) {
      return response.text();
    }
    return response.arrayBuffer();
  });
};

export const loadAssociatedDocuments = user => {
  const token = jwt.decode(user.access_token);
  //decode jwt to get client
  const client = token.client;
  const url = `https://${client}/external/docinfo`;
  return fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${user.access_token}`
    },
    credentials: 'same-origin'
  }).then(response => {
    return response.json();
  });
};

export const loadDocument = (user, docId) => {
  const token = jwt.decode(user.access_token);
  //decode jwt to get client
  console.log('token', token);
  const client = token.client;
  const url = `https://docmanagement.parchment.com/v1/api/archive/${client}/document/${docId}`;
  return fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${user.access_token}`
    },
    credentials: 'same-origin'
  }).then(response => {
    return response.json();
  });
};

export const getMeta = user => {
  const token = jwt.decode(user.access_token);
  const client = token.client;
  const url = `https://docmanagement.parchment.com/v1/api/archive/${client}/meta`;
  return fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${user.access_token}`
    },
    credentials: 'same-origin'
  }).then(response => {
    return response.json();
  });
};

export const externalLogin = (username, pass) => {
  return fetch(
    isModernApi()
      ? 'https://docmanagement.parchment.com/v1/api/archive/external/login'
      : 'https://externalview.scribonline.com/login',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        username: username,
        password: pass
      })
    }
  ).then(res => {
    return res;
  });
};
